import { ChevronRight } from 'lucide-react'
import type { ReactNode } from 'react'

export interface BreadcrumbItem {
  label: ReactNode
  href?: string
  onClick?: () => void
}

export interface BreadcrumbProps {
  items: BreadcrumbItem[]
  className?: string
  ariaLabel?: string
}

export function Breadcrumb({
  items,
  className = '',
  ariaLabel = 'Breadcrumb',
}: BreadcrumbProps) {
  return (
    <nav
      aria-label={ariaLabel}
      className={`flex items-center gap-1.5 flex-wrap ${className}`}
    >
      {items.map((item, index) => (
        <span key={index} className="flex items-center gap-1.5">
          {index > 0 && (
            <ChevronRight
              className="h-3.5 w-3.5 text-ink-secondary dark:text-dark-ink2 shrink-0"
              aria-hidden="true"
            />
          )}
          {item.href ? (
            <a
              href={item.href}
              className="text-xs font-semibold text-[#0e7490] dark:text-cyan cursor-pointer hover:underline"
            >
              {item.label}
            </a>
          ) : item.onClick ? (
            <button
              type="button"
              onClick={item.onClick}
              className="text-xs font-semibold text-[#0e7490] dark:text-cyan cursor-pointer hover:underline bg-transparent border-0 p-0"
            >
              {item.label}
            </button>
          ) : (
            <span className="text-xs font-semibold text-ink-secondary dark:text-dark-ink2">
              {item.label}
            </span>
          )}
        </span>
      ))}
    </nav>
  )
}
